import styled from 'styled-components';

import { colors , transitions} from '../../../styles/theme';

const VideoThumbTitleStyles = styled.a`
  font-family: 'Outfit', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${colors('black.base')};
  cursor: pointer;
  text-decoration: none;
  margin-top: 16px;
  width: 154px;
  height: 40px;
  transition: ${transitions('fast')};

  &:visited {
    color: ${colors('black.base')};
    transition: ${transitions('fast')};
  }

  &:hover,
  &:active {
    color: ${colors('accent.base')};
    transition: ${transitions('fast')};
  }
`;

export default VideoThumbTitleStyles;
